import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { Student } from '../../../../../models/student';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { WardsService } from '../../../../../services/wards-service/wards.service';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { FeesService } from '../../../fees/services/fees.service';
import { TeacherComment } from '../../../teachers-comments/models/teacher-comment';
import { ParentDashboard } from '../../models/parent-dashboard';
import { DashboardService } from '../../services/dashboard.service';
import { MobileDashboardScrollBottomService } from '../../services/mobile-dashboard-scroll-bottom-service/mobile-dashboard-scroll-bottom.service';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { EventsService } from '../../../calendar/services/events-service/events.service';
import { DatewiseEvents } from '../../../calendar/models/datewise-events';
import { DateUtils } from '../../../../../utils/date-utils';

@Component({
  selector: 'app-mobile-dashboard',
  templateUrl: './mobile-dashboard.component.html',
  styleUrls: ['./mobile-dashboard.component.scss']
})
export class MobileDashboardComponent extends ComponentBase implements OnInit {

  parentDashboard: ParentDashboard;
  toggle: boolean = false;
  scrollTop: number = 0;
  isUp = false;
  isScrolling = false;
  isTouching = false;
  selectedProfile: Student;
  noImage: boolean = false;
  pendingAssignments: number = 0;

  constructor(private dashboardService: DashboardService
    , private pageHeadingService: PageHeadingService
    , private wardsService: WardsService
    , private mobileDashboardScrollBottomService: MobileDashboardScrollBottomService
    , private feesService: FeesService
    , private routingService: RoutingService
    , private eventsService: EventsService) {
    super();
  }

  ngOnInit() {
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Dashboard"));
    let sub = this.dashboardService.getParentDashboard()
      .subscribe((dasboard) => {
        this.parentDashboard = dasboard
        this.toggle = !this.toggle;
        this.feesService.changeUpcomingFeeInstallment(dasboard.upcoming_fee_installment);
      });
    this.addSubscription(sub);

    let sub2 = this.wardsService.ward$
      .subscribe(ward => {
        this.selectedProfile = ward;
      });
    this.addSubscription(sub2);

    let sub3 = this.eventsService.getEvents()
      .subscribe(events => {
        this.findPendingAssignmants(events.datewise_events);
      });
    this.addSubscription(sub3);
  }

  checkForUnreadComment(teacherComments: Array<TeacherComment>): boolean {
    let unread = teacherComments.filter(o => o.is_read_by_person == false);
    if (unread.length) {
      return true;
    }
    else {
      return false;
    }
  }

  noProfilePic() {
    this.noImage = true;
  }

  onScroll(event) {
    if (event.target.scrollHeight - event.target.offsetHeight - event.target.scrollTop < 1) {
      this.mobileDashboardScrollBottomService.bottomReached(true);
    }
    else {
      this.mobileDashboardScrollBottomService.bottomReached(false);
    }
  }

  attendanceClicked() {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'attendance'];
    this.routingService.navigate(route);
  }

  findPendingAssignmants(days: Array<DatewiseEvents>) {
    let today = new Date(), day: Date;
    days.forEach(o => {
      day = DateUtils.parseDateAndTime(o.event_date);
      if (day > today || (day.getFullYear() == today.getFullYear() && day.getMonth() == today.getMonth() && day.getDate() == today.getDate())) {
        this.pendingAssignments += o.homeworks_to_be_submitted.length;
      }
    });
  }

  pendingAssignmentsClicked() {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'homeworks'];
    this.routingService.navigate(route);
  }

  myAccountClicked() {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'my-account','student'];
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }
}